import createClient, { type Client, type Middleware } from "openapi-fetch";

import type { paths } from "./generated/trading-engine.js";

export type TradingEngineClient = Client<paths>;

export interface ApiClientOptions {
  readonly baseUrl: string;
  readonly fetchImplementation?: typeof fetch;
  readonly getAccessToken: () => Promise<string | null> | string | null;
  readonly onUnauthorized: () => void;
}

export function createTradingEngineClient(options: ApiClientOptions): TradingEngineClient {
  const client = createClient<paths>({
    baseUrl: options.baseUrl,
    ...(options.fetchImplementation === undefined ? {} : { fetch: options.fetchImplementation }),
  });
  const middleware: Middleware = {
    async onRequest({ request }) {
      const accessToken = await options.getAccessToken();
      if (accessToken !== null) request.headers.set("authorization", `Bearer ${accessToken}`);
      request.headers.set("x-correlation-id", crypto.randomUUID());
      request.headers.set("accept", "application/json, application/problem+json");
      return request;
    },
    onResponse({ response }) {
      if (response.status === 401) options.onUnauthorized();
      return response;
    },
  };
  client.use(middleware);
  return client;
}
